import PageContent from '../../components/PageContent';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { getProjectsList } from '../../api/Projects';
import ProjectCommonTable from '../../components/ProjectTable';
import {Filters} from "../../components/Filters";

const sortByList = [{
    label: 'Newest to Oldest',
    id: 'id,desc'
}, {
    label: 'Oldest to Newest',
    id: 'id,asc'
}, {
  label: '$High to $Low',
  id: 'max_reward,desc'
}, {
  label: '$Low to $High',
  id: 'max_reward,asc'
}]

const Projects = () => {
  // 多语言
  const { t } = useTranslation();
  // 定义变量
  const [loading, setLoading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [pageOptions, setPageOptions] = useState({
    total: 0,
    currentPage: 1,
    perSize: 10,
  });
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
    const [types, setTypes] = useState([])
    const [sort, setSort] = useState()

    const fetchData = async () => {
        setLoading(true);
        try {
            const { data } = await getProjectsList({
                page: 1,
                pageSize: 10,
                types,
                sort
            });
            setPageOptions({
                ...pageOptions,
                total: data.total,
                currentPage: data.current_page,
                perSize: data.per_page,
            });

            for (let i = 0; i < data.list.length; i++) {
                data.list[i].key = i;
            }
            setTableData(data.list);
        } catch (_error) {
            setError(_error);
            message.error(_error.message);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [sort, types]);

  const handlePageChange = (page, pageSize) => {
    setPageOptions({
      ...pageOptions,
      currentPage: page,
      pageSize,
    });
    setLoading(true);
    getProjectsList({
      page,
      pageSize,
    types,
    sort
    })
      .then(({ data }) => {
        for (let i = 0; i < data.list.length; i++) {
          data.list[i].key = i;
        }
        setPageOptions({
          ...pageOptions,
          total: data.total,
          currentPage: data.current_page,
          perSize: data.per_page,
        });
        setTableData(data.list);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

    const handleFilter = ({sortBy, categories}) => {
        setTypes(categories)
        setSort(sortBy)
    }
    return (
    <PageContent>
        <Filters onChange={handleFilter} sortByList={sortByList} />
        <ProjectCommonTable
        type={'projectList'}
        data={tableData}
        loading={loading}
        pagination={{
          showSizeChanger: false,
          showQuickJumper: false,
          total: pageOptions.total,
          current: pageOptions.currentPage,
          pageSize: pageOptions.perSize,
          onChange: (page, pageSize) => {
            handlePageChange(page, pageSize);
          },
        }}
      />
    </PageContent>
  );
};

export default Projects;
